export enum UserTypes {
  ADMINISTRATOR = 'ADMINISTRATOR',
  MSB_SUPPORT_AGENT = 'MSB_SUPPORT_AGENT',
  MAINTAINER = 'MAINTAINER',
  INSTALLER = 'INSTALLER'
}
